import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/cash-sales')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ context, location, search }) => {
    if (!hasGrant(context.queryClient, 'accounting_cash_sale.view'))
      throw redirect({ to: '/accounting' })
    if (
      location.pathname === '/accounting/cash-sales' ||
      location.pathname === '/accounting/cash-sales/'
    ) {
      throw redirect({ to: '/accounting/sales-receipts', search })
    }
  },
  component: () => <Outlet />,
})
